import { IGroup, IPlayerGroup } from "./../../entities";
import { provider } from "../../providers";

export interface GetGroupByIdPayload {
  id: number;
  playerId: number;
}

export const GetGroupById = async (params: GetGroupByIdPayload): Promise<IPlayerGroup> =>
  provider.Request("/groups/{id}", params);
